const FIREBASE_REGION = 'us-central1';

export function getFunctionsUrl(functionName: string, env: Record<string, unknown>): string {
  if (env.VITE_FUNCTIONS_EMULATOR_HOST && env.VITE_FUNCTIONS_EMULATOR_PORT) {
    return `http://${env.VITE_FUNCTIONS_EMULATOR_HOST}:${env.VITE_FUNCTIONS_EMULATOR_PORT}/${env.VITE_FIREBASE_PROJECT_ID}/${FIREBASE_REGION}/${functionName}`;
  }

  return `https://${FIREBASE_REGION}-${env.VITE_FIREBASE_PROJECT_ID}.cloudfunctions.net/${functionName}`;
}
